class ShippingModal extends HTMLElement {
  constructor() {
    super();
    this.shippingModal = this.querySelector("[data-html-content]");
    this.button = this.querySelector("button");

    this.button.addEventListener("click", (e) => {
      const html = this.shippingModal.outerHTML;
      e.target.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "shipping-modal" },
        }),
      );
    });
  }
}

if (!customElements.get("shipping-modal")) {
  customElements.define("shipping-modal", ShippingModal);
}
